export const enum Step {
  LOCATION_FORM = 'LocationForm',
  MEMBER_FORM = 'MemberForm',
  BILLING_FORM = 'BillingForm'
}
